import { useEffect, useState } from "react"
import { BasicButton } from "../../../theme/Component/BasicButton"
import { BasicPage } from "../../../theme/Component/BasicPage"
import { BasicTable, MASK_NUMBER } from "../../../theme/Component/BasicTable"
import useDataBean from "../../../../core/services/dataBean/useDataBean"
import { _DocumentFactory, _single } from "../../../../core/services/dataBean/EntityCatalog"
import { ImportXLSX } from "../../../theme/Component/ImportXLSX"
import { PrintJson } from "../../../theme/Component/PrintJson"

export const ImportFunctionalArea = () => {

    const { lista, setLista, bean, setBean, instance } = useDataBean(_DocumentFactory)


    const [constants, setConstants] = useState<any>([]);
    const [data, setData] = useState<any>({});
    const [type, setType] = useState<number>(0);

    useEffect(()=>{
        instance.importTalentoHumanoConstants().then(
            (resp:any)=>{
                setConstants(resp);
                if(resp.length>0)
                {
                    setType(resp[0].DataBeanProperties.Property);
                }
            }
        )
    },[])

    const importFunction = () => {
        instance.importTalentoHumano(_single.getAccountID(),type,JSON.stringify(data)).then(
            (resp:any)=>{
                setLista(resp);                 
            }
        )
    }

    const head = [
        { title: 'Linea', property: 'Linea', visible: true,mask:MASK_NUMBER},        
        { title: 'Mensaje', property: 'Message', visible: true},
    ]

    return (
        <BasicPage titulo="Importar Talento Humano" >
            <div className="row">
                <div className="col-md-4">
                    <label>Tipo</label>
                    <select name="tipo" className="form-select" value={type} onChange={(e)=>{setType(parseInt(e.target.value))}}>
                        {constants.map((item,index)=>{
                            return(
                                <option value={item.DataBeanProperties.Property}>{item.DataBeanProperties.Value}</option>
                            )
                        })}
                    </select>
                </div>
                <div className="col-md-4">
                    <ImportXLSX lodaData={setData} />
                </div>
                <div className="col-md-4">
                    <BasicButton eventClick={importFunction} icon="ri-send-plane-line" useMargin children={`Importar`} />
                </div>

                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={setBean} />
                    {/* {JSON.stringify(data)} */}
                </div>
            </div>
        </BasicPage>
    )
}